import React from 'react';

const GoogleIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 24 24">
        <g clipPath="url(#a)">
            <path
                fill={color}
                d="M21.787 12.225c0-.658-.058-1.283-.159-1.892h-9.416v3.759h5.392c-.242 1.233-.95 2.275-2 2.983v2.5h3.216c1.883-1.742 2.967-4.308 2.967-7.35Z"
            />
            <path
                fill={color}
                d="M12.212 22c2.7 0 4.958-.9 6.608-2.425l-3.216-2.5c-.9.6-2.042.966-3.392.966-2.608 0-4.817-1.758-5.608-4.133H3.287v2.575C4.929 19.75 8.304 22 12.212 22Z"
            />
            <path
                fill={color}
                d="M6.604 13.908A5.803 5.803 0 0 1 6.287 12c0-.667.117-1.308.317-1.908V7.517H3.287a9.884 9.884 0 0 0 0 8.966l3.317-2.575Z"
            />
            <path
                fill={color}
                d="M12.212 5.958c1.475 0 2.792.509 3.833 1.5l2.85-2.85C17.17 2.992 14.912 2 12.212 2 8.304 2 4.929 4.25 3.287 7.517l3.317 2.575c.791-2.375 3-4.134 5.608-4.134Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M2 2h20v20H2z" />
            </clipPath>
        </defs>
    </svg>
);

export default GoogleIcon;
